export const validatePassword = (password) => {
  // (?=.*?[A-Z]) - at least one uppercase letter
  // (?=.*?[a-z]) - at least lowercase letter
  // (?=.*?[0-9]) - at least one number
  // .{8,} - min 8 characters
  const re = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$');
  return re.test(password);
};

export const validatePhone = (phone) => {
  const re = /^\+?[0-9 \-()\\\/]{6,20}$/;
  return re.test(phone);
};

export const validateEmail = (email) => {
  const re = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  return re.test(email);
};


export const validateCommaSeparatedEmails = (email) => {
  const re = /^([a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*)+([\s*,\s*]+[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*)*$/;
  return re.test(email);
};

export const validateLength = (value='', min=0, max=0) => {
  return (value.trim().length >= min) && (value.trim().length <= max);
};

export const validateBlank = (value) => {
  return !!value;
};

export const isNaturalNumber = (number) => {
  return Number.isInteger(+number) && +number >= 0;
};

export const isInteger = (number) => {
  return Number.isInteger(+number);
};

export const validateUrl = (url='') => {
  // Less restricted regex based on 3986, enough for client side validation
  let expression = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
  return !!(expression.test(url));
};

export const validateRegExp = (expression, value) => {
  return !!(expression.test(value));
}



// WEBPACK FOOTER //
// src/utils/validators.js